import React from "react";
import { Link } from "react-router-dom";
import Testimonials from "./Testimonials";
import SEO from "./SEO";
import "./LandingPage.css";

const LandingPage = ({ token }) => {
  // Decide the target route based on whether the user is logged in.
  const getStartedRoute = token ? "/member" : "/login";
  return (
    <div>
      <SEO
        title="Diviti Adora | Infrared & Red Light Studio | Oro Valley AZ"
        description="Diviti Adora Infrared Sauna & Red Light Studio in Oro Valley. Experience detoxification, rejuvenation, and holistic wellness through infrared sauna, red light therapy, chromotherapy, and halotherapy."
        keywords="infrared sauna Oro Valley AZ, red light therapy near Oro Valley, wellness center Tucson Arizona, holistic healing Oro Valley, best sauna Tucson, Oro Valley red light therapy studio, Tucson infrared sauna sessions, mind body wellness Oro Valley, preventative health solutions Tucson, natural healing therapies Arizona, self-care spa Oro Valley, alternative wellness center Tucson, health and wellness studio Marana, Southern Arizona wellness retreats"
        canonicalUrl="/"
      />
      <section className="landing-page">
        <video autoPlay loop muted className="background-video">
          <source
            src={`${process.env.PUBLIC_URL}/videos/DASS100.mp4`}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <div className="overlay">
          <h1>Welcome to Diviti Adora Infrared Sauna & Redlight Studio</h1>
          <h2>
            Proudly serving Oro Valley, Marana, Tucson, Saddlebrooke, Sun City,
            & surrounding communities.
          </h2>
          <p>Detox, rejuvenate, and restore holistically with every session.</p>
          <Link to="/products">
            <button className="cta-btn">Explore Products</button>
          </Link>
          <p></p>
          <h1 className="promo-banner">
            Create an account now and receive 1 free Flexible Session.
          </h1>
        </div>
      </section>

      {/* Features Section */}
      <section className="features" id="features">
        <h2>Our Services</h2>
        <div className="feature-container">
          <div className="feature-card">
            <a href="/infrared-info" className="feature-link">
              <img
                src={`${process.env.PUBLIC_URL}/images/sauna3.jpg`}
                alt="Infrared Sauna for detoxification in Oro Valley AZ"
                className="feature-image"
              />
              <h3>Infrared Sauna</h3>
              <p>
                Sauna that uses infrared radiation to heat the body directly,
                rather than heating the air around it.
              </p>
            </a>
          </div>
          <div className="feature-card">
            <a href="/chromotherapy-info" className="feature-link">
              <img
                src={`${process.env.PUBLIC_URL}/images/chromotherapy1.png`}
                alt="Chromotherapy for stress relief in Oro Valley wellness center"
                className="feature-image"
              />
              <h3>Chromotherapy</h3>
              <p>Harness the power of colors to boost well-being.</p>
            </a>
          </div>
          <div className="feature-card">
            <a href="/halotherapy-info" className="feature-link">
              <img
                src={`${process.env.PUBLIC_URL}/images/halo1.jpg`}
                alt="Halotherapy for breathing problems at Diviti Adora in Tucson Arizona"
                className="feature-image"
              />
              <h3>Halo Salt Therapy</h3>
              <p>
                An add-on treatment that involves breathing in salt particles to
                improve breathing and other conditions.
              </p>
            </a>
          </div>
          <div className="feature-card">
            <a href="/redlight-info" className="feature-link">
              <img
                src={`${process.env.PUBLIC_URL}/images/RedBed2.jpg`}
                alt="Red Light Therapy for skin rejuvenation and muscle recovery in Oro Valley"
                className="feature-image"
              />
              <h3>Red Light Therapy</h3>
              <p>
                The use of low levels of red light to stimulate cell
                regeneration and blood flow.
              </p>
            </a>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <Testimonials highlightedOnly={true} limit={3} />

      {/* Products Section */}
      <section className="products">
        <h2>Memberships and Products Offered</h2>
        <div className="products-cards">
          <Link to="/memberships" className="membership-link">
            <div className="products-card">
              <h3>Memberships</h3>
              <p>Choose the right membership for you</p>
            </div>
          </Link>
          {/* Studio Packages disabled until May 1, 2025 */}
          <Link to="/studio-packages" className="membership-link">
            <div className="products-card">
              <h3>Studio Packages</h3>
              <p> Enojoy our curated packages</p>
            </div>
          </Link>
          {/* Single Sessions now available */}
          <Link to="/drop-in-sessions" className="membership-link">
            <div className="products-card">
              <h3>Single Sessions</h3>
              <p>Book individual sauna or red light therapy sessions</p>
            </div>
          </Link>
          {/* Introductory Offers disabled during trial period */}
          <Link to="/gift-cards" className="membership-link">
            <div className="products-card">
              <h3>Gifts and Gift Cards</h3>
              <p>Purchase Diviti Adora Gift Cards, or Gift a session(s)</p>
            </div>
          </Link>
        </div>
      </section>

      {/* Blog Preview Section */}
      <section className="blog-preview-section">
        <h2>Wellness Insights & Updates</h2>
        <div className="blog-preview-content">
          <div className="blog-preview-text">
            <h3>Explore Our Blog</h3>
            <p>
              Discover the latest wellness tips, treatment insights, and studio
              updates on our blog. Stay informed about holistic health practices
              and get the most out of your wellness journey.
            </p>
            <Link to="/blog-preview" className="blog-preview-link">
              <button className="blog-btn">Read Our Blog</button>
            </Link>
          </div>
          <div className="blog-preview-image">
            <img
              src={`${process.env.PUBLIC_URL}/images/sauna1.jpg`}
              alt="Wellness blog preview"
            />
          </div>
        </div>
      </section>

      {/* Call-to-Action Section */}
      <section className="cta">
        <h2>Ready to get started?</h2>

        <Link to={getStartedRoute}>
          <button className="cta-btn">Sign Up Today</button>
        </Link>
      </section>

      {/* Footer with Contact Functionality */}
      <footer className="footer" id="contact">
        <p>
          &copy; {new Date().getFullYear()} Diviti Adora, LLC. All rights
          reserved.
        </p>
      </footer>
    </div>
  );
};

export default LandingPage;
